import Swiper from 'swiper';

let swiperTexteImage = {
    init() {
        $('.swiper-container').each(function(){
            var id = $(this).attr('id');
            var slide = $('#'+id+' .swiper-slide').length;
            if(slide > 1) {
                var swiper = new Swiper('#'+id+'.swiper-container.swiper-texte-image', {
                    loop: true,
                    autoplay: {
                        delay: 3000,
                    },
                    autoHeight: true,
                });
            }
        })
    }
}

export default swiperTexteImage;
